import SlideFrame from './SlideFrame';

interface Props {
  title: string; sub: string;
  th: string[];
  rows: string[][];
}

export default function IDETable({ title, sub, th, rows }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      <div className="ide-table-wrap">
        <table className="ide-table">
          <thead>
            <tr>{th.map((h, i) => <th key={i}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j} style={{ whiteSpace: 'pre-line' }}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SlideFrame>
  );
}
